import React from "react";

import { AddFilterBaseFunc, IFilterKeys, IFilters, IPlotData, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import { ChartOrientation, ChartType, QoolDashChart } from "../core";

interface IProps {
	plotData: IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

export function RemotenessChart(props: IProps) {
	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "" }}}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "Number of Diagnoses" }}}
			chartOrder={{ horizontalOrientation: { reversed: true }, verticalOrientation: { reversed: false }}}
			defaultChartOrientation={ChartOrientation.Vertical}
			defaultChartType={ChartType.Bar}
			chartTitle="Rurality"
			filterKey={DashboardFilterKeys.Remoteness.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
		/>
	)
}
